<div class="tiptap-editor-sidebar">
  @let cards = (visibleCards$ | async) ?? [];
  @let changesCount = (changesCount$ | async) ?? 0;
  @let commentsCount = (commentsCount$ | async) ?? 0;
  <div class="sidebar-top-bar">
    <div class="sidebar-tabs">
      <button type="button" class="sidebar-tab" [class.active]="filter === 'all'" (click)="selectTab('all')">
        <span class="sidebar-tab-label">{{ 'EDITOR.TRACK_CHANGES.SIDEBAR.TAB_ALL' | translate }}</span>
        <span class="sidebar-tab-count">{{ changesCount + commentsCount }}</span>
      </button>
      <button type="button" class="sidebar-tab" [class.active]="filter === 'changes'" (click)="selectTab('changes')">
        <span class="sidebar-tab-label">{{ 'EDITOR.TRACK_CHANGES.SIDEBAR.TAB_CHANGES' | translate }}</span>
        <span class="sidebar-tab-count">{{ changesCount }}</span>
      </button>
      <button type="button" class="sidebar-tab" [class.active]="filter === 'comments'" (click)="selectTab('comments')">
        <span class="sidebar-tab-label">{{ 'EDITOR.TRACK_CHANGES.SIDEBAR.TAB_COMMENTS' | translate }}</span>
        <span class="sidebar-tab-count">{{ commentsCount }}</span>
      </button>
    </div>
  </div>

  <div class="sidebar-content">
    @for (card of cards; track card.id) {
      @if (card.kind === 'suggestion') {
        <app-suggestion-card
          #cardRef
          [attr.data-card-id]="card.id"
          [suggestionId]="card.id"
          [variant]="card.variant"
          [authorName]="card.authorName"
          [createdAtRelative]="card.createdAtRelative"
          [insertionRuns]="card.insertionRuns"
          [deletionRuns]="card.deletionRuns"
          [formattingText]="card.formattingText"
          [structureText]="card.structureText"
          [canResolve]="canResolve"
          [canDiscard]="canDiscardSuggestion(card.authorId)"
          [highlighted]="card.id === highlightedCardId"
          [thread]="card.thread"
          [currentUser]="currentUser"
          [canPostComment]="canPostComment"
          (accept)="onAccept($event)"
          (reject)="onReject($event)"
          (discard)="onDiscard($event)"
          (view)="onView($event)"
          (submitComment)="onSubmitComment(card.id, $event)"
        ></app-suggestion-card>
      } @else {
        <app-comment-card
          #cardRef
          [attr.data-card-id]="card.id"
          [anchorId]="card.id"
          [quotedText]="card.quotedText"
          [orphaned]="card.orphaned"
          [isDraft]="card.isDraft"
          [authorName]="card.authorName"
          [createdAtRelative]="card.createdAtRelative"
          [highlighted]="card.id === highlightedCardId"
          [thread]="card.thread"
          [currentUser]="currentUser"
          [canPostComment]="canPostComment"
          [canResolve]="canResolveCommentThread(card.thread)"
          (view)="onViewComment($event)"
          (resolve)="onResolveComment($event)"
          (discard)="onDiscardComment($event)"
          (submitComment)="onSubmitCommentText(card.id, $event)"
        ></app-comment-card>
      }
    }
  </div>
</div>
